/* eslint-disable */
/* tslint:disable */
/* auto-generated vue proxies */
import { defineContainer } from './vue-component-lib/utils';

import type { JSX } from '@ovhcloud/ods-stencil/components/tooltip/custom-elements';

import { defineCustomElement as defineOsdsTooltip } from '@ovhcloud/ods-stencil/components/tooltip/custom-elements/osds-tooltip.js';
import { defineCustomElement as defineOsdsTooltipContent } from '@ovhcloud/ods-stencil/components/tooltip/custom-elements/osds-tooltip-content.js';


export const OsdsTooltip = /*@__PURE__*/ defineContainer<JSX.OsdsTooltip>('osds-tooltip', defineOsdsTooltip, [
  'variant'
]);


export const OsdsTooltipContent = /*@__PURE__*/ defineContainer<JSX.OsdsTooltipContent>('osds-tooltip-content', defineOsdsTooltipContent);

